import { render, staticRenderFns } from "./growerstockstatusdetail.vue?vue&type=template&id=84583250&scoped=true"
import script from "./growerstockstatusdetail.vue?vue&type=script&lang=js"
export * from "./growerstockstatusdetail.vue?vue&type=script&lang=js"
import style0 from "./growerstockstatusdetail.vue?vue&type=style&index=0&id=84583250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84583250",
  null
  
)

export default component.exports